/* What a route renders when it throws.
 *
 * `frontend-react.md` wants an error boundary at route level so one broken
 * feature does not blank the app. It says nothing the reader can act on beyond
 * "try again", on purpose: an exception message is not localisable and may
 * carry internal detail, and `i18n.md` forbids raw exception text in the UI.
 */

import { useTranslate } from '../shared/i18n/index.js';
import { AuthScreen, Button, Callout } from '../shared/ui/index.js';

export function RouteError() {
  const t = useTranslate();

  return (
    <AuthScreen title={t('error.unexpected')} brand={t('app.name')}>
      <Callout tone="danger">{t('error.unexpected')}</Callout>
      <div className="auth__actions">
        <Button block onClick={() => window.location.reload()}>
          {t('auth.verify.continue')}
        </Button>
      </div>
    </AuthScreen>
  );
}
